// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--4PORD","formItemCol":"formItemCol--1mjWM","labelInfo":"labelInfo--26vBQ","actionButton":"actionButton--2_7yW"};